import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2898fad8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "box_conts"
};
const _hoisted_2 = {
  class: "_image_box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "w100h100"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "_text_box"
};
const _hoisted_7 = {
  class: "title_box"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "time"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "btom_s"
}, null, -1));
const _hoisted_11 = {
  class: "boxs_conts"
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "topic_boxs"
};
const _hoisted_14 = {
  class: "_botom_box"
};
const _hoisted_15 = {
  class: "bt_bos"
};
const _hoisted_16 = {
  class: "item-box",
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons_ iconfont iconyy-liulan"
}, null, -1));
const _hoisted_18 = {
  style: {
    "margin-left": "3px"
  }
};
const _hoisted_19 = {
  class: "item-box"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons_ iconfont iconyy-shoucang"
}, null, -1));
const _hoisted_21 = {
  style: {
    "margin-left": "3px"
  }
};
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getCaseDetailApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'cover-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: "-1"
    }
  },
  emits: ["closeDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const itemData = ref({});
    const emit = __emit;
    function closeDialog() {
      emit("closeDialog");
    }
    async function init() {
      if (props.id != '-1') {
        const res = await getCaseDetailApi(props.id);
        itemData.value = res.data;
        console.log(itemData.value, "=====");
      }
    }
    init();
    const formattedText = computed(() => {
      // 使用正则表达式将文本按照空行分割成数组
      const lines = itemData.value.desc.trim().split(/\n\s*\n/);
      // 对每一行进行处理，添加 <br> 标签
      const formattedLines = lines.map(line => {
        return line.trim().replace(/\n/g, '<br>');
      });
      // 将处理后的行重新连接成字符串
      return formattedLines.join('<br><br>');
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        "show-close": false,
        "close-on-press-escape": false,
        top: "1vh",
        "before-close": closeDialog,
        class: "box_dia"
      }, {
        default: _withCtx(() => [itemData.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [itemData.value.type == 1 ? (_openBlock(), _createBlock(_component_el_carousel, {
          key: 0,
          interval: 5000,
          class: "_image_conts",
          arrow: "hover"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(itemData.value.img_list), item => {
            return _openBlock(), _createBlock(_component_el_carousel_item, {
              class: "item_c",
              key: item
            }, {
              default: _withCtx(() => [_createElementVNode("img", {
                class: "_pimage",
                src: item,
                alt: ""
              }, null, 8, _hoisted_3)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : _createCommentVNode("", true), itemData.value.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("video", {
          class: "w100h100",
          src: JSON.parse(itemData.value.video_list)[0],
          controls: ""
        }, null, 8, _hoisted_5)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(itemData.value.title), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(itemData.value.ct_time), 1), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", {
          class: "text_fl",
          innerHTML: formattedText.value
        }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemData.value.topic_list, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "item_pic",
            key: index
          }, "#" + _toDisplayString(item.name), 1);
        }), 128))])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(itemData.value.view_num), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(itemData.value.collect_num), 1)])])])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model-value"])]))]);
    };
  }
});